import {Controller} from "@hotwired/stimulus";
import $ from 'jquery';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static targets = [
        'myInformationSection'
    ];

    scrollToMerchantSection() {
        window.scrollTo(0, document.getElementById("my-information-section").offsetTop - 80)
    }

    scrollToMyDocumentsSection() {
        window.scrollTo(0, document.getElementById("my_documents_section").offsetTop + 230 )
    }

}
